module.exports = __webpack_public_path__ + "fonts/Num3.0ed38d83.ttf";